import { siteStats } from "@/mocks/rankings";

interface HeroSectionProps {
  onCopy: (text: string) => void;
  onOpenInstall: () => void;
}

export default function HeroSection({ onCopy, onOpenInstall }: HeroSectionProps) {
  const primaryHost = "51heilian01.top";

  return (
    <section id="top" className="relative w-full overflow-hidden bg-foreground-950">
      <div className="absolute inset-0 h-full w-full">
        <img
          src="https://readdy.ai/api/search-image?query=Dramatic%20stylized%20night%20cityscape%20with%20warm%20red%20and%20amber%20neon%20glow%2C%20abstract%20cinematic%20moody%20atmosphere%2C%20dark%20high%20contrast%20editorial%20background%2C%20no%20text&width=1920&height=1080&seq=hl-hero-main&orientation=landscape"
          alt="51黑料网官网直达最新地址入口主视觉"
          title="51黑料网 官网 最新地址 入口"
          className="h-full w-full object-cover object-top"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-foreground-950/85 via-foreground-950/70 to-foreground-950/90"></div>

      <div className="relative mx-auto w-full max-w-[1240px] px-4 pb-12 pt-14 md:px-6 md:pb-16 md:pt-20">
        <div className="flex flex-col items-start gap-5">
          <span className="inline-flex items-center gap-2 rounded-full border border-primary-400/50 bg-primary-500/20 px-4 py-1.5 text-xs font-medium text-accent-100">
            <span className="h-2 w-2 animate-soft-pulse rounded-full bg-accent-400"></span>
            官网导航 · 地址实时更新中
          </span>

          <h1 className="max-w-4xl font-heading text-3xl font-black leading-tight text-background-50 md:text-5xl lg:text-6xl">
            51黑料网官网直达
            <span className="block text-accent-300">想看瓜，先找对门</span>
          </h1>

          <p className="max-w-2xl text-sm leading-relaxed text-background-200 md:text-base">
            想进 51黑料网 却总被失效链接挡在门外？本页汇总官网、最新可用网址、入口与 app 安装方式，
            帮你快速定位当前能用的访问渠道，少走弯路直接开看。
          </p>

          <div className="w-full max-w-2xl rounded-lg border border-background-50/15 bg-background-50/10 p-4 backdrop-blur">
            <div className="flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
              <div className="flex items-center gap-3">
                <span className="flex h-10 w-10 items-center justify-center rounded-md bg-accent-500 text-foreground-950">
                  <i className="ri-link-m"></i>
                </span>
                <div>
                  <p className="text-xs text-background-300">当前推荐线路 · 10:24 检测顺畅</p>
                  <p className="font-mono text-base font-bold text-background-50 md:text-lg">{primaryHost}</p>
                </div>
              </div>
              <button
                type="button"
                onClick={() => onCopy(primaryHost)}
                className="flex cursor-pointer items-center justify-center gap-2 whitespace-nowrap rounded-md bg-background-50 px-4 py-2.5 text-sm font-bold text-foreground-950 transition-colors hover:bg-background-200"
              >
                <i className="ri-file-copy-line text-base"></i>
                复制地址
              </button>
            </div>
          </div>

          <div className="flex w-full flex-col gap-3 sm:flex-row sm:flex-wrap">
            <a
              href="#lines"
              className="flex cursor-pointer items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 text-sm font-bold text-background-50 transition-colors hover:bg-primary-600"
            >
              <i className="ri-route-line text-base"></i>
              查看全部线路
            </a>
            <button
              type="button"
              onClick={onOpenInstall}
              className="flex cursor-pointer items-center justify-center gap-2 whitespace-nowrap rounded-md border border-accent-300 bg-accent-500/15 px-6 py-3 text-sm font-bold text-accent-100 transition-colors hover:bg-accent-500/25"
            >
              <i className="ri-smartphone-line text-base"></i>
              App 下载安装
            </button>
          </div>
        </div>

        <div className="mt-10 grid grid-cols-2 gap-3 md:mt-12 md:grid-cols-4 md:gap-4">
          {siteStats.map((item) => (
            <div
              key={item.id}
              className="rounded-lg border border-background-50/15 bg-background-50/10 p-4 backdrop-blur"
            >
              <p className="font-heading text-2xl font-black text-background-50 md:text-3xl">
                {item.value}
                <span className="ml-1 text-sm font-bold text-accent-300">{item.unit}</span>
              </p>
              <p className="mt-1 text-xs text-background-300 md:text-sm">{item.label}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}